{
  "tabs": {
    "chat": "Pokalbis",
    "reminders": "Primintuvai",
    "calendar": "Kalendorius",
    "settings": "Nustatymai"
  },
  "common": {
    "cancel": "Atšaukti",
    "save": "Išsaugoti",
    "confirm": "Patvirtinti",
    "delete": "Ištrinti",
    "back": "Atgal",
    "close": "Uždaryti",
    "edit": "Redaguoti",
    "search": "Ieškoti",
    "all": "Visi",
    "loading": "Kraunama...",
    "error": "Įvyko klaida",
    "notFound": "Nerasta",
    "tryAgain": "Pabandykite dar kartą",
    "retry": "Bandykite iš naujo",
    "undo": "Anuliuoti",
    "pullToRefresh": "Nuvilkite atnaujinti",
    "justNow": "ką tik"
  },
  "auth": {
    "welcome": "Sveiki atvykę į FishMemory",
    "tagline": "Jūsų WhatsApp priminimų asistentas, dabar kišenėje.",
    "subtitle": "Jūsų WhatsApp priminimų asistentas, dabar kišenėje.",
    "phoneLabel": "Jūsų WhatsApp numeris",
    "phoneHint": "Mes atsiųsime patvirtinimo kodą per WhatsApp",
    "invalidPhone": "Įveskite galiojantį telefono numerį",
    "continue": "Tęsti",
    "enterPhone": "Įveskite savo WhatsApp numerį",
    "phonePlaceholder": "Telefono numeris",
    "sendCode": "Siųsti kodą",
    "verifyTitle": "Patvirtinkite savo numerį",
    "otpSentTo": "6 skaitmenų kodas išsiųstas į {{phone}} per WhatsApp",
    "enterFullCode": "Įveskite visus 6 skaitmenis",
    "invalidOtp": "Neteisingas kodas. Bandykite dar kartą.",
    "otpFailed": "Nepavyko siųsti kodo. Bandykite dar kartą.",
    "otpResent": "Kodas išsiųstas iš naujo",
    "resendIn": "Siųsti iš naujo po {{seconds}} s",
    "resendCode": "Siųsti kodą iš naujo",
    "enterOtp": "Įveskite kodą, išsiųstą į WhatsApp",
    "verify": "Patvirtinti",
    "resend": "Siųsti kodą iš naujo",
    "wrongNumber": "Neteisingas numeris?",
    "backToPhone": "Atgal prie telefono",
    "editPhone": "Redaguoti telefono numerį",
    "error": "Klaida",
    "setupTitle": "Sutvarkykime",
    "setupSubtitle": "Vėliau visada galite pakeisti nustatymuose",
    "namePlaceholder": "Jūsų vardas",
    "letsGo": "Baigti nustatymus",
    "skipForNow": "Praleisti dabar"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Rašykite žinutę...",
    "inputPlaceholder": "Rašykite žinutę...",
    "typing": "FishMemory rašo...",
    "online": "Prisijungęs",
    "connecting": "Jungiamasi...",
    "reconnecting": "Jungiamasi iš naujo...",
    "offline": "Atsijungęs",
    "empty": "Pradėkite pokalbį",
    "emptyHint": "Kurti priminimus, tikrinti tvarkaraštį ar prašyti pagalbos.",
    "emptyAction": "Siųsti pavyzdinį priminimą",
    "actions": "Pokalbio veiksmai",
    "keep": "Išsaugoti žinutes",
    "clearTitle": "Išvalyti pokalbį",
    "clearConfirm": "Ištrinti visas žinutes iš šio įrenginio? To nebus galima atkurti.",
    "clear": "Išvalyti pokalbį",
    "optionSelected": "Pasirinkta: {{label}}",
    "sendingSelection": "Siunčiama...",
    "connectionLost": "Jungiamasi iš naujo..."
  },
  "reminders": {
    "title": "Mano priminimai",
    "active": "Aktyvūs",
    "today": "Šiandien",
    "thisWeek": "Šią savaitę",
    "history": "Istorija",
    "items": "elementai",
    "emptyTitle": "Dar nėra priminimų",
    "emptySubtitle": "Sukurkite iš pokalbio ir jie pasirodys čia.",
    "emptyAction": "Atidaryti pokalbį",
    "filterActive": "Aktyvūs",
    "filterToday": "Šiandien",
    "filterWeek": "Šią savaitę",
    "filterHistory": "Istorija",
    "emptyState": "Dar nėra priminimų. Pradėkite pokalbį!",
    "swipeDone": "Atlikta",
    "swipeSnooze": "Atidėti",
    "swipeDelete": "Ištrinti",
    "search": "Ieškoti priminimų...",
    "upcoming": "Artėjantys",
    "completed": "Atlikti",
    "overdue": "Vėluojantys",
    "tomorrow": "Rytoj",
    "synced": "Sinchronizuota {{value}}",
    "swipeHint": "Braukite priminimą dėl daugiau veiksmų",
    "noResults": "Nėra priminimų pagal paiešką",
    "noResultsHint": "Pabandykite kitą raktažodį arba išvalykite paiešką",
    "deleteAllFailed": "Nepavyko ištrinti visų priminimų"
  },
  "calendar": {
    "title": "Kalendorius",
    "today": "Šiandien",
    "tomorrow": "Rytoj",
    "completed": "atlikta",
    "noEvents": "Nėra suplanuota",
    "noEventsSubtitle": "Pasirinkite datą, kad matytumėte priminimus ir kalendoriaus įvykius.",
    "googleEvent": "Google Kalendorius",
    "legendActive": "Aktyvūs",
    "legendRecurring": "Pasikartojantys",
    "legendDone": "Atlikti",
    "legendGoogle": "Google",
    "previousMonth": "Praėjęs mėnuo",
    "nextMonth": "Kitas mėnuo",
    "previousYear": "Praėję metai",
    "nextYear": "Kiti metai",
    "goToToday": "Eiti į šiandien",
    "all": "Visi",
    "active": "Aktyvūs",
    "done": "Atlikti",
    "paused": "Pristabdyti"
  },
  "settings": {
    "title": "Nustatymai",
    "profile": "Profilis",
    "name": "Rodymo vardas",
    "enterName": "Įveskite savo vardą",
    "language": "Kalba",
    "uiLanguage": "Programėlės kalba",
    "uiLanguageHelp": "Keičia programėlės sąsają, kalendoriaus etiketes ir išdėstymo kryptį tik šiame įrenginyje.",
    "serverLanguage": "Pokalbio kalba",
    "serverLanguageHelp": "Keičia kalbą, kuria serveris atsako ir siunčia priminimus jūsų paskyrai.",
    "timezone": "Laiko juosta",
    "currentTimezone": "Dabartinė laiko juosta",
    "timezoneHelp": "Visi priminimų laikai rodomi pagal šią laiko juostą.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Išsaugoti laiko juostą",
    "timezoneSaved": "Laiko juosta atnaujinta",
    "detect": "Nustatyti",
    "detectFailed": "Nepavyko nustatyti laiko juostos",
    "autoDetect": "Automatiškai nustatyti pagal GPS",
    "notifications": "Pranešimai",
    "notificationsHelp": "Pakartotiniai priminimai kontroliuoja pasikartojančius įspėjimus po priminimo gavimo. Įrenginio pranešimų leidimai valdomi telefone.",
    "pushEnabled": "Push pranešimai",
    "autoDoneOnFire": "Automatiškai pažymėti atliktu",
    "autoDoneOnFireDesc": "Išjungus, priminimai lieka aktyvūs, kol pažymite juos atliktais.",
    "googleCalendar": "Google Kalendorius",
    "google": "Google Kalendorius",
    "googleConnected": "Prisijungta",
    "googleDisconnected": "Nėra prisijungimo",
    "googleConnectedHelp": "Nauji priminimai gali būti automatiškai sinchronizuojami su kalendoriumi.",
    "googleDisconnectedHelp": "Prisijunkite prie Google Kalendoriaus, kad priminimai ir įvykiai būtų suderinti.",
    "googleConnectFailed": "Nepavyko prisijungti prie Google Kalendoriaus",
    "connected": "Prisijungta",
    "disconnected": "Nėra prisijungimo",
    "connect": "Prisijungti",
    "disconnect": "Atsijungti",
    "autoSync": "Automatinė naujų priminimų sinchronizacija",
    "autosync": "Automatinė naujų priminimų sinchronizacija",
    "subscription": "Prenumerata",
    "trialUsed": "Bandomasis: {{used}}/{{total}} panaudota",
    "trialStatus": "Bandomasis prieinamas",
    "activeStatus": "Aktyvi prenumerata",
    "expiredStatus": "Prenumerata pasibaigė",
    "unsubscribedStatus": "Nėra prenumeratos",
    "about": "Apie",
    "version": "Versija",
    "logout": "Atsijungti",
    "logoutTitle": "Atsijungti",
    "logoutConfirm": "Ar tikrai norite atsijungti?",
    "noName": "Vardas nenustatytas",
    "serverConnection": "Serverio ryšys",
    "serverUrl": "Serverio URL",
    "serverEdit": "Redaguoti",
    "saveReconnect": "Išsaugoti ir prisijungti iš naujo",
    "resetDefault": "Atstatyti numatytuosius",
    "invalidServerUrlTitle": "Neteisingas serverio URL",
    "invalidServerUrlMessage": "Įveskite galiojantį http arba https serverio URL, pvz., https://example.com",
    "uiLanguageChangeFailed": "Nepavyko pakeisti programėlės kalbos. Bandykite dar kartą.",
    "serverLanguageChangeFailed": "Nepavyko pakeisti pokalbio kalbos. Bandykite dar kartą.",
    "timezoneChangeFailed": "Nepavyko pakeisti laiko juostos. Bandykite dar kartą.",
    "autoSyncChangeFailed": "Nepavyko atnaujinti automatinės sinchronizacijos. Bandykite dar kartą.",
    "nameChangeFailed": "Nepavyko atnaujinti rodomo vardo. Bandykite dar kartą.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Priminimo detalės",
    "editTime": "Redaguoti laiką",
    "rename": "Pervardyti",
    "snooze": "Atidėti",
    "snooze15": "Atidėti 15 minučių",
    "pause": "Pristabdyti",
    "pauseReminder": "Pristabdyti priminimą",
    "resume": "Tęsti",
    "resumeReminder": "Tęsti priminimą",
    "skip": "Praleisti kitą",
    "skipOccurrence": "Praleisti šį kartą",
    "syncGoogle": "Sinchronizuoti su Google",
    "delete": "Ištrinti",
    "deleteTitle": "Ištrinti priminimą",
    "deleteConfirm": "Šis priminimas bus visam laikui ištrintas.",
    "deleteRecurringTitle": "Ištrinti pasikartojantį priminimą",
    "deleteRecurringMessage": "Ar norite praleisti šį kartą, ar ištrinti visą seriją?",
    "deleteThisOccurrence": "Praleisti šį kartą",
    "deleteEntireSeries": "Ištrinti visą seriją",
    "done": "Atlikta",
    "markDone": "Pažymėti kaip atliktą",
    "undo": "Atkurti",
    "undoPrompt": "Reikia vėl aktyvuoti? Atkurkite dabar.",
    "recurring": "Pasikartojantis",
    "nextRun": "Kitas kartojimas",
    "oneTime": "Vienkartinis",
    "pending": "Laukiantis",
    "sent": "Išsiųstas",
    "paused": "Pristabdytas",
    "active": "Aktyvus",
    "snoozed": "Atidėtas",
    "localTime": "Rodyti jūsų vietos laiku",
    "recurrence": "Pasikartojimas",
    "created": "Sukurta",
    "tags": "Žymės",
    "fireCount": "Kartų įvykdytas",
    "actions": "Veiksmai",
    "none": "Nėra",
    "snoozeFailed": "Nepavyko atidėti priminimo",
    "pauseFailed": "Nepavyko pristabdyti priminimo",
    "resumeFailed": "Nepavyko tęsti priminimo",
    "skipFailed": "Nepavyko praleisti priminimo",
    "doneFailed": "Nepavyko pažymėti priminimo kaip atlikto",
    "undoFailed": "Nepavyko atkurti priminimo būsenos",
    "deleteFailed": "Nepavyko ištrinti priminimo",
    "rescheduleTitle": "Perplanuoti?",
    "rescheduleMsg": "Šis priminimas vėluoja. Ar norite jį perplanuoti?",
    "reschedule15": "Po 15 minučių",
    "reschedule60": "Po 1 valandos",
    "keepOverdue": "Palikti kaip yra"
  },
  "onboarding": {
    "slide1Title": "Sveiki atvykę į FishMemory",
    "slide1Sub": "Jūsų asmeninis priminimų asistentas — veikia per WhatsApp ir sukurtas kišenei.",
    "slide2Title": "Tiesiog kalbėkite natūraliai",
    "slide2Sub": "Rašykite priminimus taip, kaip galvojate: „Primink man paskambinti mamai rytoj 15 val.“ — mes pasirūpinsime likusiu.",
    "slide3Title": "Niekada nieko nepraleiskite",
    "slide3Sub": "Gaukite laiku pranešimus, tvarkykite žymėmis ir būkite visada informuoti apie svarbiausius dalykus.",
    "getStarted": "Pradėti",
    "next": "Kitas",
    "firstReminderTitle": "Sukurkite pirmą priminimą!",
    "firstReminderHint": "Pabandykite įvesti ką nors panašaus:",
    "firstReminderExample": "Primink man išgerti vandens rytoj 9 val.",
    "gotIt": "Supratau!",
    "notifRationaleTitle": "Būkite laiku",
    "notifRationaleBody": "FishMemory reikia pranešimų, kad primintų laiku. Gaunate įspėjimus tik apie savo sukurtus priminimus.",
    "notifRationaleAllow": "Įjungti pranešimus",
    "notifRationaleLater": "Gal vėliau",
    "swipeHint": "Braukite į dešinę greitiems veiksmams →",
    "calendarDragHint": "Tempkite, kad išplėstumėte ↕"
  }
}
